import { Injectable, signal } from "@angular/core";

@Injectable({ providedIn: "root" })
export class SelectedCityService {
  readonly selectedCity = signal<string | null>(null);

  setCity(city: string | null): void {
    this.selectedCity.set(city);
  }
}
